import styled from "styled-components";
import { ChevronRightIcon } from "../Icons";

export const Wrapper = styled.li`
  display: flex;
  align-items: center;
  padding: 0px;
`;

export const Chevron = styled(ChevronRightIcon)`
  margin: 0 -8px;
`;

export const BreadcrumbWrapper = styled.ul`
  display: flex;
  margin: 0;
  padding-left: unset;
`;

export const CollapserContent = styled.span`
  display: flex;
  align-items: center;
  padding: 8px;
  color: var(--mode-overrides-header-text-weak);
`;
